import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProductoCarta = ({ title, content, description, linkText, linkNavigation, svg }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    if (linkNavigation) {
      navigate(linkNavigation); // Navega dinámicamente al enlace proporcionado
    }
  };

  return (
    <div className="relative h-[25rem] w-full sm:w-[18rem] [perspective:1000px] group mx-auto">
      <div className="absolute h-full w-full transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
        {/* Front Face */}
        <div className="absolute h-full w-full rounded-2xl bg-gradient-to-br from-zinc-800 to-zinc-900 border border-zinc-700 shadow-xl overflow-hidden transition-all duration-500 group-hover:border-blue-500 group-hover:shadow-2xl group-hover:shadow-blue-500/20 flex flex-col [backface-visibility:hidden]">
          <div className="h-1 bg-gradient-to-r from-zinc-900 via-zinc-500 to-zinc-100"></div>

          {/* Icono - Altura fija */}
          <div className="h-48 flex items-center justify-center relative p-6">
            <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500">
              <div className="absolute inset-6 rounded-full bg-gradient-to-br from-gray-900 to-gray-500 blur-2xl"></div>
            </div>
            <div className="relative z-10 transform transition-transform duration-500 group-hover:scale-110">
              <div className="w-32 h-32 text-white rounded-full bg-gradient-to-br from-zinc-700 to-zinc-800 flex items-center justify-center border border-zinc-600 transition-colors duration-500">
                {svg}
              </div>
            </div>
          </div>

          {/* Título y Descripción - Altura fija */}
          <div className="px-6 pb-6 flex flex-col gap-3">
            <h3 className="text-lg font-messina tracking-wider text-white text-center group-hover:text-blue-300 transition-colors duration-300 min-h-[3.5rem] flex items-center justify-center">
              {title}
            </h3>
            <h4 className="font-light text-zinc-300 text-center leading-relaxed line-clamp-2">{description}</h4>
          </div>
        </div>

        {/* Back Face */}
        <div className="absolute inset-0 h-full w-full rounded-lg bg-gradient-to-b from-zinc-800 to-zinc-900 shadow-inner px-10 text-center text-white [transform:rotateY(180deg)] [backface-visibility:hidden] flex flex-col">
          <div className="flex min-h-full flex-col text-black items-center justify-around py-5">
            <p className="text-lg text-left font-light text-white">{content}</p>
            <div className="relative">
              <a
                onClick={handleLinkClick}
                className="text-xl text-right relative cursor-pointer inline-block text-white"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {linkText}
                <span
                  className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-300 ease-in-out ${
                    isHovered ? 'w-full' : 'w-0'
                  }`}
                ></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductoCarta;
